import { render } from "./RefReg.vue?vue&type=template&id=0f82a8de"
import script from "./RefReg.vue?vue&type=script&lang=js"
export * from "./RefReg.vue?vue&type=script&lang=js"

import "./RefReg.vue?vue&type=style&index=0&id=0f82a8de&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__